import React, { useState, useEffect } from 'react';
import './Newsletter.css';
import { supabase } from '../supabaseClient';

export const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.fade-in-section');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementBottom = element.getBoundingClientRect().bottom;
        const isVisible = (elementTop < window.innerHeight - 100) && (elementBottom > 0);
        if (isVisible) {
          element.classList.add('is-visible');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check visibility on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsAnimating(true);

    const data = { email };

    try {
      if (!supabase) throw new Error('Service not configured yet.');

      const { error: dbError } = await supabase
        .from('newsletter')
        .insert([data]);

      if (dbError) throw new Error(dbError.message);

      // Send email notification via edge function (non-blocking)
      supabase.functions.invoke('send-email', {
        body: { type: 'newsletter', data },
      }).catch(() => {});

      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    } finally {
      setTimeout(() => {
        setStatus('');
        setIsAnimating(false);
      }, 3000);
    }
  };

  return (
    <section className="newsletter-section fade-in-section">
      <div className="newsletter-container">
        <div className="newsletter-content">
          <h2 className="newsletter-title">Stay Inspired</h2>
          <div className="title-line"></div>
          <p className="newsletter-description">
            Subscribe to receive exclusive updates, behind-the-scenes content, and inspiring stories from our latest shoots.
          </p>
          
          <form onSubmit={handleSubmit} className="newsletter-form">
            <div className="input-group">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="newsletter-input"
                disabled={isAnimating}
              />
              <button 
                type="submit" 
                className={`subscribe-button ${isAnimating ? 'animating' : ''} ${status}`}
                disabled={isAnimating}
              >
                {status === 'success' ? (
                  <span className="success-message">✓ Subscribed</span>
                ) : status === 'error' ? (
                  <span className="error-message">Please try again</span>
                ) : (
                  'Subscribe'
                )}
              </button>
            </div>
          </form>
          
          <p className="privacy-note">
            By subscribing, you agree to receive our newsletter. We respect your privacy and will never share your information.
          </p>
        </div>
        
        <div className="newsletter-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-text">Stories by Kalakaar</div>
          <div className="decoration-line"></div>
        </div>
      </div>
    </section>
  );
}; 